module.exports = __webpack_public_path__ + "static/img/3.20d76901.png";